var image_viewer_rtlignore_default = {
  "fontElementMap": "Tz8Mr",
  "imageContainer": "Eq0zE",
  "expandContainer": "Ag3Ph",
  "expandIcon": "qqKW0",
  "pointer": "cM624",
  "imageWrapper": "bPMFg",
  "imageRatio": "Fc1mT",
  "image": "V1DsN",
  "imageOverlay": "DMGHP",
  "imagePreload": "ep--O",
  "imageHighres": "_-5TKc",
  "onlyHighRes": "xSxZF",
  "image_loading": "N9S46"
};
export {
  image_viewer_rtlignore_default as default
};
//# sourceMappingURL=image-viewer.rtlignore-scss.js.map
